import { AINA_INTRO_STORAGE_KEY } from "@repo/utils";

export function readAinaIntroDismissed(): boolean {
  if (typeof window === "undefined") return true;
  try {
    return window.localStorage.getItem(AINA_INTRO_STORAGE_KEY) === "1";
  } catch {
    return true;
  }
}

export function writeAinaIntroDismissed() {
  try {
    window.localStorage.setItem(AINA_INTRO_STORAGE_KEY, "1");
  } catch {
    /* ignore */
  }
}

/** Call on logout so the next account can see the marketing intro. */
export function clearAinaIntroDismissed() {
  try {
    window.localStorage.removeItem(AINA_INTRO_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
